import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Eski HashRouter linklerini (/#/elidor) yeni yola (/elidor) taşı
if (window.location.hash.startsWith('#/')) {
  const p = window.location.hash.slice(1);
  window.history.replaceState(null, '', p);
}

const container = document.getElementById('root');

// Ön-render (Puppeteer) çıktısı ReactDOMServer üretimi olmadığından hydrateRoot
// benign bir mismatch üretir; bunun yerine createRoot ile temiz render ediyoruz.
// Crawler'lar zaten statik ön-render edilmiş HTML'i alır.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

